import LocationSearch from '@Core/components/locationSearch';
import { ComponentLoader } from '@bythepixel/component-loader';
import windowMatchMedia from '@Front/constants/windowMatchMedia';
import { setContentHeight } from './utility';

setContentHeight();

windowMatchMedia['break-3'].addListener(() => {
  setContentHeight();
});

window.LocationSearch = new ComponentLoader(document, [LocationSearch]);
